import React, { Component } from 'react';
import { trackEvent } from '../../../utils';
import './styles.css';

export default class ContactUs extends Component {
 onChangeTel = () => {
     trackEvent('help');
     window.location.href = 'tel:' + this.props.i18n.serviceNumber;
 }
  render() {
    const { i18n } = this.props
    return (
        <div className='contact-us'>
                <div className='contact-box font-body1'>
                    <div className='contact-part part1'>
                        <div className = 'contact-item icon'><i className="icon icon-phone"></i></div>
                        <div className = 'contact-item'>
                            <div className = 'contact-title'>{i18n.supportService}</div>
                            <a className='contact-tel mobile' onClick={this.onChangeTel}>
                                {i18n.serviceNumber}
                            </a>
                            <a className='contact-tel pc'>
                                {i18n.serviceNumber}
                            </a>
                        </div>
                    </div>
                    <div className='contact-part'>
                        <div className = 'contact-item icon'><i className="icon icon-clock"></i></div>
                        <div className = 'contact-item'>
                            <div className = 'contact-title'>{i18n.timeRange}</div>
                            <div className='contact-time'>{i18n.rangeWorkDay}</div>
                            <div className='contact-time'>{i18n.rangeWeekend}</div>
                        </div>
                    </div>
                    <div className='contact-part'>
                        <div className = 'contact-item icon'><i className="icon icon-message"></i></div>
                        <div className = 'contact-item'>
                            <div className = 'contact-title'>{i18n.makeAnAppointment.title}</div>
                            <div className='contact-appointment'>{i18n.makeAnAppointment.subTitle}</div>
                            <div className='contact-appointment'>
                                <a className="contact-appointment_btn" href={i18n.makeAnAppointment.url} target="_blank">
                                    <span>{i18n.makeAnAppointment.btn}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/ContactUs/components/ContactUs.js